export const ROOT_URL =
  process.env.NODE_ENV === 'production'
    ? 'https://admin.zhitiaox.com'
    : 'http://localhost:4000';

// export const ROOT_URL = "https://admin.zhitiaox.com";
export const ZHITIAO_HOST = 'https://api.zhitiaox.com';
